__turbopack_context__.v({
  "active": "yUmkua_active",
  "backButton": "yUmkua_backButton",
  "buttonWrapper": "yUmkua_buttonWrapper",
  "categoryIconWrapper": "yUmkua_categoryIconWrapper",
  "categoryItem": "yUmkua_categoryItem",
  "categoryItemAllProducts": "yUmkua_categoryItemAllProducts",
  "categoryItemLabel": "yUmkua_categoryItemLabel",
  "categoryItemWrapper": "yUmkua_categoryItemWrapper",
  "categoryList": "yUmkua_categoryList",
  "column": "yUmkua_column",
  "drawerHeader": "yUmkua_drawerHeader",
  "header": "yUmkua_header",
  "mobileCategoryNameWrapper": "yUmkua_mobileCategoryNameWrapper",
  "numberOfProducts": "yUmkua_numberOfProducts",
  "root": "yUmkua_root",
  "selectCurrentCategoryButton": "yUmkua_selectCurrentCategoryButton",
  "title": "yUmkua_title",
  "titleWrapper": "yUmkua_titleWrapper",
});
